import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const VirtualMachine = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='VirtualMachine' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,23 L14,23 L14,10 L1,10 L1,23 Z M10,19 L23,19 L23,6 L10,6 L10,19 Z M5,14 L18,14 L18,1 L5,1 L5,14 Z' />
  </StyledIcon>
);
